var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0462 18.4147C16.2653 20.1958 13.9212 21.0582 11.5917 21.0079C9.26397 20.9575 5.64487 20.9712 3.89526 20.9819C3.33609 20.9853 2.8839 20.533 2.88826 19.9739C2.90203 18.2075 2.92803 14.531 2.92627 12.1574C2.92459 9.88939 3.78812 7.62185 5.52156 5.88879C8.97693 2.43216 14.5908 2.43216 18.0462 5.88791C21.5077 9.34988 21.5015 14.959 18.0462 18.4147Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22199 12.5187H8.1272",
    stroke: "#CCCCCC",
    strokeWidth: 1.44,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8069 12.5188H11.7122",
    stroke: "#CCCCCC",
    strokeWidth: 1.44,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.392 12.5187H15.2972",
    stroke: "#CCCCCC",
    strokeWidth: 1.44,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationIcon);
export default __webpack_public_path__ + "static/media/conversationIcon.92ed021eebad48aa0af892bc18bf1d38.svg";
export { ForwardRef as ReactComponent };